/****   http.js   ****/
// 导入封装好的axios实例
import request from './request'

const http ={
    /**
     * methods: 请求
     * @param url 请求地址 
     * @param params 请求参数
     */
    get(url,params){
        const config = {
            method: 'get',
            url:url,
        }
        if(params) config.params = params
        return request(config)
    },
    getPdf(url,params){
        const config = {
            method: 'get',
            url:url,
            responseType: 'blob',
        }
        if(params) config.params = params
        return request(config)
    },
    postPdf(url,params,files){
        const config = {
            method: 'post',
            url:url,
            type:'postpdf',
            ContentType:false,
            dataType: 'json',
            data:files,
            responseType: 'blob',
        }
        if(params) config.params = params
        console.log(config,"configsconfigs")
        return request(config)
    },
    postFile(url,params){
        const config = {
            method: 'post',
            url:url,
            type:'postFile',
            ContentType: false,
            // dataType: 'json',
            data:params,
            // responseType: 'json',
            processData:false,
            transformRequest : [function(){
                return params;
            }]
        }
        // if(params) config.params = params
        // console.log(config,"configsconfigs")
        console.log(params);
        return request(config)
    },
    getExcel(url,params){
        const config = {
            method: 'get',
            url:url,
            responseType: 'arraybuffer',
        }
        if(params) config.params = params
        return request(config)
    },
    post(url,params){
        const config = {
            method: 'post',
            url:url
        }
        if(params) config.data = params
        return request(config)
    },
    put(url,params){
        const config = {
            method: 'put',
            url:url
        }
        if(params) config.params = params
        return request(config)
    },
    delete(url,params){
        const config = {
            method: 'delete',
            url:url
        }
        if(params) config.params = params
        return request(config)
    },
    deleteN(url,params){
        const config = {
            method: 'delete',
            type: 'new',
            url:url
        }
        if(params) config.params = params
        return request(config)
    }
}
//导出
export default http